import { render, staticRenderFns } from "./CompanyProgramMainJourney.vue?vue&type=template&id=f70e57e0"
import script from "./CompanyProgramMainJourney.vue?vue&type=script&lang=js"
export * from "./CompanyProgramMainJourney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports